import { combineReducers } from 'redux';
import users from './users.reducer';

export default combineReducers({
  users,
});
